@if(dataMenuTree().length === 0){
<div class="loading-state">Cargando...</div>
}@else{
<ng-container *transloco="let e; read: 'routing'">
  <div class="tree-header">
    <h4 class="header-title">{{ e(routing()) }}</h4>
  </div>
</ng-container>

<mat-tree #tree [dataSource]="dataMenuTree()[0]?.children || []" [childrenAccessor]="childrenAccessor"
  class="tree-container">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [style.--mat-tree-node-indent-size]="'10px'"
    class="leaf-node">
    <div class="node-spacer"></div>
    <a [routerLink]="node.path" routerLinkActive="active" class="node-link"
      (auxclick)="handleLinkInteraction($event, node.path)" (click)="handleLinkInteraction($event, node.path)">
      <span class="node-text">{{node.name}}</span>
    </a>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
    [style.--mat-tree-node-indent-size]="'10px'" matTreeNodeToggle [cdkTreeNodeTypeaheadLabel]="node.name"
    class="parent-node">
    <div class="parent-content">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" class="expand-button">
        <mat-icon class="mat-icon-rtl-mirror expand-icon" [class.rotated]="isNodeExpanded(node)">expand_more</mat-icon>
      </button>
      <span class="parent-text">{{node.name}}</span>
    </div>
  </mat-tree-node>
</mat-tree>
}